
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useSEO, generateWebPageSchema } from '../../utils/seo';

const TalismansPage = () => {
  // SEO設定
  useSEO({
    title: '京都山科 授与品一覧 | 大石神社',
    description: '大石神社の授与品のご案内。お守り、御朱印、御朱印帳、絵馬、おみくじ、破魔矢、熊手など各種授与品をご用意しております。',
    keywords: 'お守り,御朱印,絵馬,おみくじ,授与品,大石神社,京都,山科',
    canonical: '/talismans',
    schema: generateWebPageSchema('授与品一覧', '大石神社の授与品。お守り、御朱印、絵馬、おみくじなど各種授与品をご用意', '/talismans')
  });

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar />
      
      <div className="pt-32 pb-24">
        <div className="max-w-7xl mx-auto px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-16"
          >
            <h1 className="text-[#D4AF37] font-serif text-6xl font-bold mb-6 tracking-wide">授与品一覧</h1>
            <div className="w-24 h-[1px] bg-[#D4AF37] mx-auto mb-8"></div>
            <p className="text-white text-lg leading-relaxed">
              大石神社では、様々な授与品をご用意しております。
            </p>
          </motion.div>

          {/* 準備中のお知らせ */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="flex flex-col items-center justify-center py-24"
          >
            <div className="w-24 h-24 flex items-center justify-center mb-8">
              <i className="ri-tools-line text-[#D4AF37] text-6xl"></i>
            </div>
            <h2 className="text-white font-bold text-3xl mb-6 tracking-wide">準備中</h2>
            <p className="text-gray-400 text-center leading-relaxed max-w-md">
              現在、授与品ページを準備しております。<br />
              しばらくお待ちください。
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mt-12 bg-[#1A1A1A] border border-[#D4AF37]/30 rounded-lg p-10"
          >
            <div className="flex items-start gap-6">
              <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                <i className="ri-information-line text-[#D4AF37] text-3xl"></i>
              </div>
              <div>
                <h3 className="text-white font-bold text-xl mb-4 tracking-wide">授与品についてのご案内</h3>
                <div className="text-gray-400 text-sm leading-loose space-y-2">
                  <p>・授与品は社務所にて授与しております。</p>
                  <p>・受付時間：9:00〜17:00</p>
                  <p>・御朱印は御朱印帳をお持ちの方に限り授与いたします。</p>
                  <p>・郵送での授与は行っておりません。直接お越しください。</p>
                  <p>・価格は変更になる場合がございます。</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TalismansPage;
